const ICONS =
  'a > i.icon-toggle, a > i.icon-toggle-sm, a > i.icon-toggle-md, a > i.icon-toggle-lg';
const DURATION = 350;
const ANIMATING = 'disclosure-panel--animating';

// panel -> { animation, open } while its height animates
const running = new WeakMap();

const prefersReducedMotion = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// a closing panel keeps `hidden` off until its animation ends, so read the target state
export function isPanelOpen(panel) {
  return running.get(panel)?.open ?? !panel.hidden;
}

export function setPanelOpen(panel, open, animate = true) {
  syncTriggers(panel.id, open);

  const from = panel.hidden ? 0 : panel.getBoundingClientRect().height;
  running.get(panel)?.animation.cancel();
  running.delete(panel);
  panel.hidden = false;
  const to = open ? panel.getBoundingClientRect().height : 0;

  if (!animate || from === to || !panel.animate || prefersReducedMotion()) {
    panel.classList.remove(ANIMATING);
    panel.hidden = !open;
    return;
  }

  panel.classList.add(ANIMATING);
  const animation = panel.animate(
    { height: [`${from}px`, `${to}px`] },
    { duration: DURATION, easing: 'ease' },
  );
  running.set(panel, { animation, open });
  animation.finished.then(
    () => {
      running.delete(panel);
      panel.classList.remove(ANIMATING);
      panel.hidden = !open;
    },
    () => {}, // cancelled by a newer toggle, which now owns the panel
  );
}

function syncTriggers(id, open) {
  document.querySelectorAll('[aria-controls]').forEach((trigger) => {
    if (trigger.getAttribute('aria-controls') !== id) return;
    trigger.setAttribute('aria-expanded', open);
    trigger.querySelectorAll(ICONS).forEach((icon) => {
      icon.classList.toggle('fa-minus', open);
      icon.classList.toggle('fa-plus', !open);
    });
  });
}
